import { removeRsFromValue, validatePriceQtyInput } from "../../../../utils";
import { LanguageContext } from "../../../../context/LanguageContext";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { useContext, useEffect, useState } from "react";
import withObservables from "@nozbe/with-observables";
import { getUnArchivedStock, updateStockCostPrice, updateStockSellPrice } from "../../../../database/helpers/stock";
import styles from "./styles.module.css";
import AddQuickBody from "../AddQuickBody";
import { formatNum, uuid } from "../../../../oscar-pos-core/constants";
import AddQuickHeader from "../AddQuickHeader";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { sentenceCase, YESNO } from "../../../../constants";
import { NewPlusIcon, PlusBlueIcon } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

export const item_def = {
  id: "",
  name: "",
  price: "",
  qty: "",
  amount: "",
  isNew: "",
};

const AddQuickItem = ({
  all_items,
  handleAddItem,
  updateAmountWithTotal,
  itemObj,
  isITook,
  id = "",
  isDisplayUpdateAmountSection = true,
  required = false,
}) => {
  const [items, setItems] = useState({});
  const { showSnackbar } = useSnackbar();
  const [I18n] = useContext(LanguageContext);
  const [isUpdateTotalAmount, setIsUpdateTotalAmount] = useState(
    isDisplayUpdateAmountSection ? YESNO.Yes : YESNO.No,
  );
  const [total, setTotal] = useState();
  const [isAddItem, setIsAddItem] = useState(false);
  useEffect(() => {
    if (Object.values(itemObj).length) setItems(itemObj);
  }, [itemObj]);

  const handleItemClick = (item, index = -1) => {
    const tempItem = { ...items };
    if (tempItem[item.id]) {
      showSnackbar({
        message: I18n.already_exist_item,
        severity: "error",
      });
      return;
    } else {
      triggerLogEvent(analytics, "sb_quick_item_added", {
        item_name: item?.name,
      });
      if (index != -1) {
        let values = Object.values(tempItem);
        values[index] = {
          id: item.id,
          name: item.name,
          stock: item.stock,
          cost_price: Number(item.cost_price) || 0,
          selling_price: Number(item.selling_price) || 0,
          quantity: 1,
          modal: item.stock,
        };
        let newObj = values.reduce((acc, value) => {
          acc[value.id] = value;
          return acc;
        }, {});
        setItems(newObj);
        handleAddItem(Object.values(values));
        return;
      }
      tempItem[item.id] = {
        id: item.id,
        name: item.name,
        stock: item.stock,
        cost_price: Number(item.cost_price) || 0,
        selling_price: Number(item.selling_price) || 0,
        quantity: 1,
        modal: item.stock,
      };
      setItems(tempItem);
      handleAddItem(Object.values(tempItem));
      setIsAddItem(false);
    }
  };
  const handleAddStock = async (itemName) => {
    triggerLogEvent(analytics, "sb_quick_item_new_stock_added", {
      item_name: itemName,
    });
    const tempItem = { ...items };
    const id = uuid();
    tempItem[id] = {
      id: id,
      name: itemName,
      cost_price: 0,
      selling_price: 0,
      quantity: 1,
      isNew: true,
    };
    setItems(tempItem);
    handleAddItem(Object.values(tempItem));
    setIsAddItem(false);
  };

  const handleUpdateQuantity = (inputVal, id) => {
    const tempItem = { ...items };
    if (validatePriceQtyInput(inputVal)) {
      tempItem[id].quantity = +inputVal;
      setItems(tempItem);
      handleAddItem(Object.values(tempItem));
    }
  };

  const handleUpdatePrice = (inputVal, id) => {
    const tempItem = { ...items };
    if (validatePriceQtyInput(inputVal)) {
      const result = removeRsFromValue(inputVal);
      const newPrice = Number(result) || 0;
      tempItem[id][isITook ? "cost_price" : "selling_price"] = newPrice;
      tempItem[id][isITook ? "updated_cost_price" : "updated_selling_price"] =
        newPrice;
      setItems(tempItem);
      handleAddItem(Object.values(tempItem));
    }
  };
  const handleDeleteItem = (item) => {
    let tempItem = { ...items };
    delete tempItem[item.id];
    setItems(tempItem);
    handleAddItem(Object.values(tempItem));
  };

  useEffect(() => {
    handleAmount();
  }, [items, isITook]);

  const handleAmount = (isForceUpdate = false) => {
    if ((Object.values(items) || []).length) {
      let amount = (Object.values(items) || []).reduce(
        (value, data) =>
        (value +=
          data.quantity * (isITook ? data.cost_price : data.selling_price)),
        0,
      );
      setTotal((prevAmount) => {
        if (prevAmount !== amount || isForceUpdate) {
          if (isUpdateTotalAmount === YESNO.Yes || isForceUpdate) {
            updateAmountWithTotal(amount);
          }
        }
        return amount;
      });
    } else {
      setTotal();
    }
  };

  const handleUpdateAmountToogle = (newvalue) => {
    if (newvalue === YESNO.Yes) handleAmount(true);
    setIsUpdateTotalAmount(newvalue);
  };

  const onUpdateStockPrice = async (item) => {
    try {
      if (isITook)
        await updateStockCostPrice(item?.id, item?.cost_price);
      else
        await updateStockSellPrice(item?.id, item?.selling_price);
    } catch (error) {
    }
  };


  return (
    <div className={`${styles.wrapper} AddQuickItemWrapper`}>
      <div className={styles.itemTable}>
        <AddQuickHeader required={required} />
        {(Object.values(items) || []).length > 0 ? (
          (Object.values(items) || []).map((item, index) => (
            <AddQuickBody
              key={item.id || index}
              index={index}
              handleAddStock={handleAddStock}
              handleUpdateQuantity={(qty) => handleUpdateQuantity(qty, item.id)}
              handleItemClick={(e) => handleItemClick(e, index)}
              handleUpdatePrice={(price) => handleUpdatePrice(price, item.id)}
              name={item.name}
              price={isITook ? item.cost_price : item.selling_price}
              qty={item.quantity}
              allItems={all_items}
              isAddfromStock={!item.isNew}
              handleDeleteItem={() => handleDeleteItem(item)}
              id={id}
              onUpdateStockPrice={(e) => onUpdateStockPrice(item)}
            />
          ))
        ) : (
          <AddQuickBody
            index={"AddQuick"}
            handleAddStock={handleAddStock}
            handleItemClick={handleItemClick}
            allItems={all_items}
            id={id}
            required={required}
          />
        )}
        {(Object.values(items) || []).length > 0 && isAddItem && (
          <AddQuickBody
            index={"AddQuick"}
            handleAddStock={handleAddStock}
            handleItemClick={handleItemClick}
            allItems={all_items}
            id={id}
            required={required}
          />
        )}
      </div>

      <UBButton
        tabIndex={0}
        id={`${id}_add_item`}
        onClick={() => {
          setIsAddItem(true);
        }}
        disabled={!(Object.values(items) || []).length}
        iconComponent={<NewPlusIcon width={20} height={20} />}
        title={sentenceCase(I18n.add_line_item)}
        className="buttonTeritary addLineItemButton"
      />

      {isDisplayUpdateAmountSection &&
        (Object.values(items) || []).length > 0 && (
          <div
            className={`${styles.updateAmountItemtotalWrapper} updateAmountItemtotalWrapper`}
          >
            <div className={styles.updateAmountItemtotal}>
              <ParagraphText className="fontSize12">
                {I18n.update_amount_with_item_total}
              </ParagraphText>
              <Box className={styles.toggleButtonWrapper}>
                <ToggleButtonGroup
                  color="primary"
                  value={isUpdateTotalAmount}
                  exclusive
                  onChange={(_, newvalue) => handleUpdateAmountToogle(newvalue)}
                  aria-label="Platform"
                >
                  <ToggleButton id={`${id}_yesBtn`} value={YESNO.Yes}>
                    {I18n.yes}
                  </ToggleButton>
                  <ToggleButton id={`${id}_noBtn`} value={YESNO.No}>
                    {I18n.no}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </div>
            <ParagraphText
              id={`${id}_amount`}
              className="fontSize12 fontWeight600"
            >{`${I18n.total}: Rs. ${formatNum(total || 0)}`}</ParagraphText>
          </div>
        )}
    </div>
  );
};

const enhance = withObservables(["stock"], ({ stock }) => ({
  all_items: getUnArchivedStock(localStorage.getItem("business_id")),
}));
export default enhance(AddQuickItem);
